import settings from "@/settings";
import { Vue, Component } from "vue-property-decorator";
import Modal from "@/components/modal/modal.vue";
import { authService } from "@/services/authService";

@Component({ components: { Modal } })
export default class MainHeader extends Vue {
    displayProductInfo: boolean = false;
    get product(): { title: string, description: string, metadata: string, tableDates: string } {
        return settings.product;
    }

    downloadMetadata() {
        window.open(this.product.metadata, "_blank");
        this.displayProductInfo = !this.displayProductInfo;
    }

    logout() {
        this.$emit('logout');
    }

    get username(): string | null {
        return authService.getUsername();
    }
}